module.exports = __webpack_public_path__ + "static/media/2-desktop.47e3033e.jpg";